// extracted by mini-css-extract-plugin
module.exports = {"smallest-font-size":"styles-module__smallest-font-size___3MFeT"};